module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Rolling-pin-2a992b77c1c35d7da699e53b8f146347.svg";